module.exports = __webpack_public_path__ + "495cf2430f7bfa72d175de3fd1ae15af.svg";